/* eslint-disable react/no-multi-comp */
import React, {useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {imageIcEdit24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {
	relatedObjectsConfig,
	getHeadersForBodyType,
	getConfigurationForEntity,
	getLabelNoObjectsForBodyType
} from './config';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import Utility from '../../../../../../util/utilityfunctions';
import {FormBodyTypeIdContext} from '../../FormBodyContainer';
import {clientSideEventNames, EngagementCommentStatus, entities} from '../../../../../../util/uiconstants';
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator';
import ManageBodyRelatedObjectsModal from './ManageObjects/ManageBodyRelatedObjectsModal';
import {DocumentEngagementIdContext, DocumentTypeIdContext} from '../../../../../Main/Forms/CanvasFormContainer';
import {
	useClearAllComments,
	useDocumentId,
	useEngagementId,
	useUserPreferences
} from '../../../../../../util/customHooks';
import BodyKnowledgeDescription from '../../BodyKnowledgeDescription';
import Icon from '../../../../BaseComponentWrappers/MotifIcon';
import {GetCardTypeForBody} from '../../../../../../util/utils';

function BodySpecial(props) {
	const {
		bodyContent,
		getBodiesBySectionId,
		headerId,
		sectionId,
		bodyId,
		showGuidance,
		guidanceFilter,
		isSnapshotView,
		className
	} = props;

	const [showManageObjects, setShowManageObjects] = useState(false),
		[haveManageObjectChanges, setHaveManageObjectChanges] = useState(false),
		[commentCount, setCommentCount] = useState(-1),
		[showOverlayLoader, setShowOverlayLoader] = useState(false),
		[isTargetEng, setIsTargetEng] = useState(false);

	const formBodyTypeId = useContext(FormBodyTypeIdContext),
		documentId = useDocumentId(),
		engagementId = useEngagementId(),
		documentEngagementId = useContext(DocumentEngagementIdContext),
		userPreferences = useUserPreferences(),
		documentTypeId = useContext(DocumentTypeIdContext);

	const formBodyBorder = GetCardTypeForBody(bodyContent);

	const bodyComments =
		bodyContent && bodyContent.engagementComments
			? bodyContent.engagementComments.filter(
					(comment) => comment.engagementCommentStatusId !== EngagementCommentStatus.closed
			  ).length
			: 0;

	const engagementComments = useSelector((store) => {
		let comments = [];
		if (store.engagementComments[props.bodyContent.id]) {
			if (store.engagementComments[props.bodyContent.id].length > 0) {
				comments = store.engagementComments[props.bodyContent.id].filter((c) => {
					return c.engagementCommentStatusId !== EngagementCommentStatus.closed;
				});
			} else {
				comments = [];
			}
		}
		return comments;
	});

	let headers = <></>;
	let bodyRelatedObjects = bodyContent.bodyRelatedObjects;

	const mainKey = `bro-${bodyContent.id}-main`;

	// Get body's header configuration
	const headersList = getHeadersForBodyType(
		bodyContent.bodyTypeId,
		bodyContent.bodyRelatedObjects && bodyContent.bodyRelatedObjects[0] && bodyContent.bodyRelatedObjects[0].entityId
	);
	const headerCount = headersList.length;

	headers = headersList?.map((header, index) => {
		let headerClassName = 'entity-name';
		if (headerCount === 1) {
			headerClassName = 'entity-name single-column';
		} else if (index === 0) {
			headerClassName = 'entity-name';
		} else {
			headerClassName = 'entity-data';
		}

		// Custom classes for the header
		if (header.styleName) {
			headerClassName += ` ${header.styleName}`;
		}

		let headerKey = `${mainKey}-header-${index}`;

		return (
			<section key={headerKey} className={`header-${headerClassName}`}>
				<EllipsesControl content={header.label} tooltip={header.label} noOfLines={2} />
			</section>
		);
	});

	const manageObjectsConfiguration = relatedObjectsConfig.bodyManageObjects[bodyContent.bodyTypeId];

	function showManageObjectsModal() {
		if (!showManageObjects === true) {
			setShowManageObjects(!showManageObjects);
		}
	}

	function onRelatedObjectCheckChanged(object, checked) {
		setHaveManageObjectChanges(true);
	}

	const onCloseManageObjects = () => {
		if (haveManageObjectChanges) {
			window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
			getBodiesBySectionId(bodyId);
		}

		setShowManageObjects(false);
		setHaveManageObjectChanges(false);
	};

	const {setClearAllComments} = useClearAllComments(
		engagementId,
		documentId,
		documentTypeId,
		entities.FormBody,
		bodyId,
		() => {
			setShowOverlayLoader(false);
			setClearAllComments(false);
			getBodiesBySectionId(bodyId);
		}
	);

	useEffect(() => {
		if (engagementComments === undefined) {
			setCommentCount(bodyComments);
		} else {
			setCommentCount(engagementComments.length);
		}
	}, [engagementComments]);

	useEffect(() => {
		if (documentEngagementId !== undefined) {
			if (Number(engagementId) !== Number(documentEngagementId)) {
				setIsTargetEng(true);
			}
		}
	}, [documentEngagementId]);

	const rightSideButton = !(userPreferences.isGuestUser && !userPreferences.isCEAPUser) &&
		!isTargetEng &&
		manageObjectsConfiguration && (
			<StyledRightButton
				title={manageObjectsConfiguration.iconLabel}
				onClick={() => {
					showManageObjectsModal();
				}}
			>
				<Icon src={imageIcEdit24px} title={manageObjectsConfiguration.iconLabel} />
			</StyledRightButton>
		);

	return (
		<>
			<LoadingIndicator show={showOverlayLoader} styleName="independenceLoader" />
			<BodySpecialWrapper key={mainKey} className={`SectionBodyWrapper ${formBodyBorder} ${className || ''}`}>
				<BodyKnowledgeDescription
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
					isSnapshotView={isSnapshotView}
					bodyModel={bodyContent}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={bodyContent.name}
					isCustom={bodyContent.isCustom}
					isDuplicate={bodyContent.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
					rightSideButton={rightSideButton}
				/>
				{showManageObjects && manageObjectsConfiguration && (
					<ManageBodyRelatedObjectsModal
						engagementId={engagementId}
						documentId={documentId}
						bodyId={bodyId}
						configurationInfo={manageObjectsConfiguration}
						bodyRelatedObjects={bodyRelatedObjects}
						showModal={showManageObjects}
						onClose={onCloseManageObjects}
						onRelatedObjectCheckChanged={onRelatedObjectCheckChanged}
					/>
				)}
				<section className="SectionBodyData SpecialBodyData">
					<section className="header-container">{headers}</section>
					<section key="scroll" className="body-container customScrollbar">
						{bodyRelatedObjects && bodyRelatedObjects.length > 0 ? (
							bodyRelatedObjects.sort(Utility.sortByMultipleKey('entityName')).map((object) => {
								return getConfigurationForEntity(object.entityId).render(object, {
									isTopLevel: true,
									bodyId: bodyContent.id
								});
							})
						) : (
							<section className="entity-content placeholder-text">
								<EllipsesControl
									content={getLabelNoObjectsForBodyType(formBodyTypeId)}
									tooltip={getLabelNoObjectsForBodyType(formBodyTypeId)}
									noOfLines={1}
								/>
							</section>
						)}
					</section>
				</section>
			</BodySpecialWrapper>
		</>
	);
}

export default BodySpecial;

const StyledRightButton = styled.section`
	margin-right: var(--px-10) !important;
	display: inline-flex;
	svg {
		width: var(--px-20) !important;
		height: var(--px-20) !important;
		vertical-align: middle;
		fill: var(--neutrals-700);
	}
`;

const BodySpecialWrapper = styled.section`
	border: var(--px-1) solid var(--neutrals-300);
	.SectionBodyDescriptionHeaders {
		display: flex;
		align-items: flex-start;
		padding: var(--px-10);
		.SectionBodyDescription {
			&.special-body-title {
				font-weight: 500;
				padding: 0;
				width: calc(100% - var(--px-170));
				display: inline-flex;
				padding-right: var(--px-10);
			}
		}
		.SectionBodyRightIcons {
			display: inline-flex;
			width: var(--px-170);
			flex-wrap: wrap;
			align-content: flex-start;
			.FirstRowIcons {
				display: flex;
				width: 100%;
				justify-content: flex-end;
			}
			.SecondRowIcons {
				display: flex;
				margin-left: auto;
				margin-top: var(--px-5);
				.hiddenIcon {
					display: none;
				}
				.showIcon {
					display: inline-block;
				}
			}
			.comments-icon {
				display: inline-flex;
				max-width: var(--px-80);
				z-index: 9;
				padding-right: var(--px-10);
				.commentsIconSpan {
					margin-right: 0 !important;
					display: flex;
					align-items: center !important;
					.motif-icon {
						&.active {
							svg {
								color: var(--neutrals-00white);
							}
						}
					}
				}
				svg {
					width: var(--px-20) !important;
					height: var(--px-20) !important;
					vertical-align: middle;
					color: var(--neutrals-700);
				}
				.commentsCounts {
					display: inline-block;
					padding: 0 var(--px-5);
					font-size: var(--px-12);
					font-weight: 400;
					color: var(--neutrals-700);
					cursor: pointer;
					line-height: var(--px-18);
				}
			}
			.sectionBody-validation {
				display: inline-flex;
				max-width: var(--px-60);
				width: auto;
				margin-left: var(--px-10);
			}
			.relate-document-icon {
				display: inline-flex;
				max-width: var(--px-60);
				margin-left: var(--px-10);
				position: relative;
				left: 0;
				z-index: 8;
				span {
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				svg {
					width: var(--px-20) !important;
					height: var(--px-20) !important;
					vertical-align: middle;
					color: var(--neutrals-700);
					fill: var(--neutrals-700);
					transform: rotate(125deg);
				}
				.relateDocumentsCounts {
					display: inline-block;
					padding-left: var(--px-5);
					font-size: var(--px-12);
					font-weight: 300;
					color: var(--neutrals-700);
					cursor: pointer;
				}
			}
			.custom-icon,
			.description-icon,
			.edit-icon,
			.delete-icon {
				display: inline-flex;
				margin: 0 var(--px-5);
				svg {
					width: var(--px-20) !important;
					height: var(--px-20) !important;
					vertical-align: middle;
					fill: var(--neutrals-700);
					cursor: default;
				}
			}
			.edit-icon,
			.delete-icon {
				svg {
					cursor: pointer;
				}
			}
		}
	}
	.SectionBodyData {
		flex-direction: column;
	}
	.header-container {
		display: flex;
		font-weight: normal;
		color: var(--neutrals-900);
		background-color: var(--neutrals-200);
		border: var(--px-1) solid var(--neutrals-300);
		padding: var(--px-10);
		width: 100%;
		.header-entity-name {
			width: calc(100% - var(--px-163));
			display: flex;
			padding-right: var(--px-10);
			&.single-column {
				width: 100%;
			}
		}
		/* Custom header classes */
		.it-app-header {
			width: calc(100% - var(--px-60));
		}
		.remove-btn-header {
			width: var(--px-50);
			min-width: auto !important;
		}
		/* /Custom header classes */
		.header-entity-data {
			max-width: var(--px-200);
			min-width: var(--px-150);
			display: inline-flex;
			&.remove-btn {
				min-width: auto;
				width: var(--px-50);
			}
		}
	}
	.placeholder-text {
		font-size: var(--px-14);
		font-weight: 100;
		padding: var(--px-10);
	}
	.body-container {
		border: var(--px-1) solid var(--neutrals-300);
		border-top: 0;
		background: var(--neutrals-00white);
		width: 100%;
		padding: 0 var(--px-10);
		max-height: var(--px-300);
		.entity-content {
			display: flex;
			.entityContentText {
				display: flex;
				font-size: var(--px-14);
				font-weight: normal;
				width: calc(100% - var(--px-100));
				align-items: center;
				color: var(--neutrals-900);
				&.noRelatedObjectsFound {
					padding-left: var(--px-15);
					font-weight: 100;
				}
			}
			&.placeholder-text {
				font-size: var(--px-14);
				font-weight: 100;
				padding: var(--px-10) 0;
			}
			&.entity-content-level-1 {
				border-bottom: var(--px-1) solid var(--neutrals-300);
				padding: var(--px-10) 0;
				&:last-child {
					border: 0;
				}
			}
			&.entity-content-level-2 {
				padding-left: var(--px-20);
			}
			&.entity-content-level-3 {
				padding-left: var(--px-20);
			}
			&.entity-content-level-4 {
				padding-left: var(--px-20);
				&.WcgwRelatedObject {
					.WcgwRelatedObjectWrapper {
						max-width: 100%;
						display: inline-flex !important;
					}
				}
			}
			.RelatedObjectTextWrapper {
				max-width: calc(100% - var(--px-50));
				width: auto;
				font-size: var(--px-14);
				color: var(--blue-600);
				font-weight: 100;
				min-height: var(--px-20);
				display: inline-flex;
				align-items: center;
				line-height: var(--px-20);
			}
			.CountWrapper {
				background: var(--neutrals-900);
				color: var(--neutrals-00white);
				padding: var(--px-2) var(--px-10);
				font-size: var(--px-12);
				border-radius: var(--px-10);
				height: var(--px-20);
				display: inline-flex;
				line-height: normal;
			}
		}
		button {
			svg {
				margin-top: var(--px-5);
			}
		}
		.entity-content-main {
			font-size: var(--px-14);
			color: var(--blue-600);
			display: inline-flex;
			font-weight: 300;
			line-height: var(--px-20);
			&:hover {
				text-decoration: none;
				cursor: default;
			}
			.diffins {
				background-color: #e6ffe6;
				font-family: inherit;
				text-decoration: none;
			}
			.diffdel {
				color: #999;
				background-color: #ffe6e6;
				font-family: inherit;
			}
			.mod {
				background-color: #ffe1ac;
				font-family: inherit;
			}
		}
		.entity-content-data {
			max-width: var(--px-200);
			cursor: default;
			margin-left: 0;
			padding-left: var(--px-3);
			line-height: normal;
			min-width: var(--px-150);
			.ellipses {
				align-items: flex-start;
			}
			&.ThirdCol {
				justify-content: center;
				display: inline-flex;
				color: var(--neutrals-700);
				&.effectiveness-not-selected {
					color: var(--neutrals-700);
				}
				&.effectiveness-ineffective {
					color: var(--red-600);
				}
			}
		}
	}
`;

const StyledAddCommentsWrappers = styled.section`
	padding: var(--px-10) var(--px-20);
	height: 100%;
	font-size: var(--px-14);
	display: flex;
	flex-direction: column;

	.BodyDescriptinTxt {
		margin-bottom: var(--px-10);
	}
	.AddCommentBtn {
		margin-bottom: var(--px-10);
		width: var(--px-150);
	}
	.EngagementCommentsViewBox {
		.EngagementCommentBody {
			overflow: hidden;
			padding-bottom: var(--px-40);
		}
	}
`;
